import HelmetTags from "./HelmetTags"

function NotFound() {
  ;<HelmetTags title="This page does not exist. Please return to the home page." />
  return <div className="w-full h-screen flex justify-center items-center">404 Page Not Found</div>
}

export default NotFound
